import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { baseStyleSheet } from '../../../../styles/styles';
import { isOfferedOnAccount } from '../../../integrations/ExternalIntegrations/availableProviders';
import { getProviderLogoUrl } from '../../../integrations/ExternalIntegrations/providerLogos';
import { GenericIntegrationGraphic } from '../../../svgs/graphics/GenericIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { hubSpotColor, styleSheet } from './styles';

export const DashboardHubSpotV2IntegrationCard = () => {
	const userSession = useUserSession();
	const { getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } = useIntegrationCard({
		closeIntegrationEventName: 'HubSpotV2IntegrationClosed',
		enableUrlPath: `/integrations/${Api.IntegrationProvider.HubSpot}`,
		integrationEnableEventName: 'HubSpotV2IntegrationEnableClick',
		pendingAction: Api.PendingActions.ConnectHubSpot,
	});

	if (!showCard || !userSession.isAdmin || !isOfferedOnAccount(Api.IntegrationProvider.HubSpot, userSession.account)) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={
				<>
					<img
						src={getProviderLogoUrl(Api.IntegrationProvider.HubSpot)}
						alt='HubSpot CRM Logo'
						className={css(styleSheet.graphic)}
					/>
					<span className={css(styleSheet.integrationGraphic)}>
						<GenericIntegrationGraphic color={hubSpotColor} />
					</span>
				</>
			}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect HubSpot CRM',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				children: 'Connect HubSpot CRM',
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				HubSpot CRM is enabled for your account and needs a HubSpot service key to sync. Once connected, Levitate will
				pull your contacts and their owners.
			</p>
			<p>If your HubSpot CRM sync was already set up, the key was rejected or expired and a new one is needed.</p>
		</IntegrationCard>
	);
};
